import AccessLogSwitch from './AccessLogSwitch';

export default AccessLogSwitch;
